import React from 'react';
import './style.scss';

interface Props {
  id?: string;
  text: string;
}

const RollingLane = ({ id, text }: Props) => {
  return (
    <div id={id} className='rolling-lane-wrapper'>
      <div className='rolling-lane'>
        {[...Array(10)].map((_, index) => (
          <div className='rolling-lane-block' key={index}>
            {text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RollingLane;
